import { Component, OnInit } from '@angular/core';

import {AlertController, ModalController, Platform, PopoverController} from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { MenuController } from '@ionic/angular';
import {SwUpdate} from '@angular/service-worker';
import {DarkModeService} from './services/darkmode.service';
import { Capacitor } from '@capacitor/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private platform: Platform,
    private menu: MenuController,
    public popoverController: PopoverController,
    private swUpdate: SwUpdate,
    private alertController: AlertController,
    private darkModeService: DarkModeService) {
    this.initializeApp();
  }

  private backPresses = 0;
  private maxBackPresses = 2;
  private deviceAndroid = false;
  public knowledgeLink = environment.knowledge_ref;

  initializeApp() {

    this.platform.ready().then(async () => {
      if (Capacitor.isPluginAvailable('StatusBar')) {
        await StatusBar.setStyle({ style: Style.Default });
      }
      await SplashScreen.hide();
      if (this.swUpdate.isEnabled) {
        this.swUpdate.versionUpdates.subscribe(event => {
          if (event.type === 'VERSION_READY') {
            console.log('new version found.');
            datadogRum.addAction('Version Update', {
              eventType: 'version_ready',
              component: 'AppComponent'
            });
            window.location.reload()
          }
        });
      }
    });
  }

  async checkMode(){
    let mode =  await this.darkModeService.getDarkMode();
    if (mode !== ''){
      mode = (mode === 'true');
      if (mode) {
        document.body.classList.add('dark');
        document.body.classList.toggle('dark', true);
      }else{
        document.body.classList.remove('dark');
        document.body.classList.toggle('light', true);
      }    }
  }

  ngOnInit() {
    this.menu.enable(true)
  }

}